var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"no-text-transform",staticStyle:{"height":"60px"},attrs:{"block":"","color":this.$route.params.id == _vm.id ? 'green lighten-4' : 'white'},on:{"click":function($event){return _vm.goToBenefit(_vm.id)}}},[_c('span',{staticStyle:{"white-space":"normal"}},[_vm._v(_vm._s(_vm.name))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }